import { useCallback, useEffect, useState } from 'react';
import sessionsReportApi from 'Api/axios/sessions-report-api';

/**
 * Single responsibility: fetch the precomputed course-level KPIs that drive
 * the in-course "Sesiones" tab header. Aggregation is server-side; the
 * frontend renders the result without recomputing.
 *
 * Endpoint: GET /api/reports/sessions/summary?courseId=<uuid>
 * Permission: session.report.read
 */
export default function useSessionsStatsApi({ courseId, init = true } = {}) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStats = useCallback(async () => {
    if (!courseId) return null;
    setLoading(true);
    setError(null);
    const response = await sessionsReportApi.getCourseSummary(courseId);
    if (response.error) {
      setError(response.error);
      setStats(null);
    } else {
      setStats(response.data || null);
    }
    setLoading(false);
    return response;
  }, [courseId]);

  useEffect(() => {
    if (init && courseId) fetchStats();
  }, [courseId, init, fetchStats]);

  return { stats, loading, error, fetchStats };
}
